const { NODE_ENV, REACT_APP_MAP_ID, REACT_APP_MODE_DEBUG } = process.env;

export const IS_DEVELOPMENT = NODE_ENV === 'development';
export const MODE_DEBUG = IS_DEVELOPMENT && REACT_APP_MODE_DEBUG === '1';

export const KEY_CODE_ENTER = 13;
export const TABLET_MAX_WIDTH = 768;
export const MOBILE_MAX_WIDTH = 375;

export const ZINDEX = {
  LOADER_SPINNER: 9999905,
  MAP: 1000,
  MAP_CONTROLS: 1005,
  MODAL: 9010,
};

export const EVENT_TYPES = {
  DRAFT_CANCEL: 'onDraftCancel',
  DRAFT_CREATE: 'onDraftCreate',
  EDITMODE_DISABLED: 'onEditModeDisabled',
  EDITMODE_ENABLED: 'onEditModeEnabled',
  EDITMODE_TOGGLE: 'onEditModeToggle',
  FILTERS_CHANGE: 'onFiltersChange',
  LASTCENTER_UPDATE: 'onLastCenterUpdate',
  MARKERS_LOADED: 'onMarkersLoaded',
  MARKER_COMMIT: 'onMarkerCommit',
  MARKER_DELETE: 'onMarkerDelete',
  MODAL_CLOSE: 'onModalClose',
  MODAL_OPEN: 'onModalOpen',
  NAVIGATION_TOGGLE: 'onNavigationToggle',
  TODO_IMPORT: 'onImportTodo',
  TODO_TOGGLE: 'onToggleTodo',
  USER_LOGOUT: 'onUserLogout',
};

/* ----------------------------------------

 specifics to game

---------------------------------------- */
export const APP_MAP_ID = REACT_APP_MAP_ID;
export const PERSIST_STORAGE_KEY = `smart-maps::${APP_MAP_ID}::localStorage`;
